import Chat from './Chat';
import ChatOpener from './ChatOpener';
import Donuts from './Donuts';
import FloatingDots from './FloatingDots';
import AnimateText from './AnimateText';
import Magnetic from './Magnetic';
import Menu from './Menu';
import MenuOpener from './MenuOpener';

const Components = {
    Chat,
    ChatOpener,
    Donuts,
    FloatingDots,
    AnimateText,
    Magnetic,
    Menu,
    MenuOpener,
};

export default Components;


// WEBPACK FOOTER //
// ./components/index.js